export const getHeatmapIntensity = (activityCount: number, maxActivityCount: number) => {
    if (!activityCount) return 0;

    return .25 + (.75 * Math.sqrt(activityCount / maxActivityCount));
};
